module.exports = __webpack_public_path__ + "media/images/message_top-83f06ffc82a459e5753a4e268ab436ca.png";